(function () {
  'use strict';

  angular
    .module('app.dashboard', [
      'app.dashboard.main',
    ]);

})();
